<template>
    <div class="print:hidden">
        <footer class="footer bg-white text-black text-sm p-4 md:p-8">
            <div class="container md:flex divide-y divide-grey-400 md:divide-y-0">
                <div class="w-full py-4 md:p-0 md:mb-8">
                    <contact :model="model" />
                </div>
                <div class="w-full py-4 md:p-0 md:mb-8">
                    <h3 class="font-bold text-base mb-2">
                        {{model.footer.columnTwoTitle}}
                    </h3>
                    <div v-html="model.footer.columnTwoText" v-epi-edit="'ColumnTwoText'" class="o-textarea"></div>
                </div>
                <div class="w-full py-4 md:p-0 md:mb-8">
                    <h3 class="font-bold text-base mb-2">
                        Andre relevante nettsteder
                    </h3>
                    <EpiLink v-epi-edit="'ExternalLinks'" :key="link.title" :target="link.target" :title="link.title" :url="link.href" v-for="link in model.footer.externalLinks" class="underline hover:text-green-400">{{link.text}}<br /></EpiLink>
                </div>
                <div class="w-full py-4 md:p-0 md:mb-8">
                    <social :model="model" />
                    <login :model="model" />
                </div>
            </div>
        </footer>
        <div v-if="model.footer.editor" class="text-center">
            <footer class="footer bg-grey-800 text-grey-400 text-xs p-2">
                <font-awesome-icon class="fa-sm" icon="copyright" /> {{model.footer.copyright}}  Redaktør: <b>{{model.footer.editor}}</b>
            </footer>
        </div>
    </div>
</template>

<script>
import EpiLink from '@/Scripts/components/atoms/EpiLink/index.vue';
import Contact from '@/Scripts/components/organisms/Contact/contact.vue';
import Social from '@/Scripts/components/organisms/Social/social.vue';
import Login from '@/Scripts/components/organisms/Login/login.vue';

export default {
    props: ['model'],
    components: {
        EpiLink,
        Contact,
        Social,
        Login
    }
};
</script>
